import { v } from '../validation'

export const postTimerFormSchema = v.object({
  matterTimerId: v.number().label('Matter timer ID').required(),
  attendanceNote: v.string().label('Attendance note').nullable(),
  jCodePhaseTaskCode: v.string().label('J Code Phase Task Code').nullable(),
  jCodeActivityCode: v.string().label('J Code Activity Code').nullable(),
  rateType: v.string().label('Rate type').required(),
  rateAmount: v.number().label('Rate amount').nullable(),
  timeAmount: v.number().label('Time amount').nullable(),
  description: v.string().label('Description').max(60).required(),
  timeRecordingActivityId: v.string().label('Time recording activity ID').required(),
  remunerationTypeId: v.string().label('Remuneration type ID').required(),
  postingDate: v.string().label('Posting date').required(),
  feeEarnerId: v.string().label('Fee earner ID').required(),
  matterNo: v.number().label('Matter no').required(),
  clientNo: v.string().label('Client no').required()
})

export const createPostingFormSchema = v.object({
  clientNo: v.string().label('Client no').required(),
  matterNo: v.number().label('Matter no').required(),
  remunerationTypeId: v.string().label('Remuneration type ID').required(),
  postingDate: v.string().label('Posting date').required(),
  feeEarnerId: v.string().label('Fee earner ID').required(),
  attendanceNote: v.string().label('Attendance note').nullable(),
  jCodePhaseTaskCode: v.string().label('J Code Phase Task Code').nullable(),
  jCodeActivityCode: v.string().label('J Code Activity Code').nullable(),
  timeLedgerPostingsActivities: v.array().label('Time ledger postings activities').required()
})
